<div class="courses-schedule">
    <div class="courses">
        <h2>Courses Schedule</h2>
        <p-dropdown [options]="courses" [(ngModel)]="selectedCourse" optionLabel="courseName" optionValue="courseID" [style]="{ width: '100%' }" (onChange)="changeCourse()"></p-dropdown>
    </div>
    <hr>

    <!-- Search Bar -->
    <div class="search-container mb-4 mt-4 flex flex-row justify-content-between align-items-center" [ngClass]="{'disabled': !schedule || schedule.length === 0}">
        <span class="p-input-icon-left w-50">
            <i class="pi pi-search"></i>
            <input type="text" pInputText [(ngModel)]="searchText" (input)="filterSchedule()" placeholder="Search in schedule..." class="w-100" />
        </span>
        <div class="course-controls">   
            <button 
                type="button" 
                class="btn btn-primary download-btn"
                (click)="downloadPDF()"
                [disabled]="!schedule || schedule.length === 0 || loader"
                title="Download PDF">
                <i class="pi pi-download"></i>
                Download PDF
            </button>
        </div>
        
    </div>

    <!-- No Schedule Message -->
    <div *ngIf="!schedule || schedule.length === 0 && !loader" class="no-schedule-message text-center p-4 flex flex-column justify-content-center align-items-center">
        <i class="pi pi-calendar-times" style="font-size: 3rem; color: #ccc;"></i>
        <h4 class="mt-3">No Schedule Available</h4>
        <p class="text-muted">There is no schedule available for the selected course.</p>
    </div>

    <!-- Schedule Table -->
    <div class="table-responsive" *ngIf="schedule && schedule.length > 0">
        <table class="table table-bordered schedule-table">
            <thead class="table-light">
                <tr>
                    <th>System</th>
                    <th>Subject</th>
                    <th>Content</th>
                    <th>Number of Sessions</th>
                    <th>Duration</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let subject of filteredSchedule">
                    <tr>
                        <td [attr.rowspan]="subject.systems.length + 1" class="align-middle fw-bold">
                            {{ subject.name }}
                        </td>
                        <td colspan="2"></td>
                        <td class="align-middle text-center fw-bold">{{ subject.systems.length }}</td>
                        <td class="align-middle text-center fw-bold">
                            {{ getTotalDuration(subject.systems) }}
                        </td>
                    </tr>
                    <ng-container *ngFor="let system of subject.systems">
                        <tr>
                            <td class="align-middle" [innerHTML]="highlightText(system.name)"></td>
                            <td [innerHTML]="highlightText(system.content) | safeHtml"></td>
                            <td class="align-middle text-center"></td>
                            <td class="align-middle text-center">
                                {{ getSystemDuration(system) }}
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>

<app-overlay-loader *ngIf="loader"></app-overlay-loader>